// Navigation utilities for dynamic routing to products page
import { slugify } from "./index";

export function buildProductUrl(id: number | string, name: string, brand?: string): string {
  const namePart = slugify(name);
  const brandPart = brand ? slugify(brand) : "";
  const prefix = [brandPart, namePart].filter(Boolean).join("-");
  return prefix ? `/product/${prefix}-${id}` : `/product/${id}`;
}

/**
 * Generate URL for products page with category/subcategory filters
 */
export const getProductsPageUrl = (params: {
  categoryId?: number | null;
  subCategoryId?: number | null;
}) => {
  const urlParams = new URLSearchParams();
  
  if (params.categoryId) {
    urlParams.set('category_id', params.categoryId.toString());
  }
  
  if (params.subCategoryId) {
    urlParams.set('sub_category_id', params.subCategoryId.toString());
  }
  
  const queryString = urlParams.toString();
  return queryString ? `/products?${queryString}` : '/products';
};

/**
 * Navigate to products page with specific category
 */
export const navigateToCategory = (categoryId: number) => {
  return getProductsPageUrl({ categoryId });
};

/**
 * Navigate to products page with specific subcategory
 */
export const navigateToSubCategory = (categoryId: number, subCategoryId: number) => {
  return getProductsPageUrl({ categoryId, subCategoryId });
};
